<template>
  <div class="project-dialog">
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               :width="!jobsiteID ? '80%' : '60%'"
               top="5vh"
               :modal-append-to-body="true"
               :append-to-body="true"
               :show-close="false"
               :title="title">
      <el-button @click="handleSkip()"
                 size="small"
                 type="primary"
                 style="position:absolute;right:10px; top:10px"
                 v-show="!jobsiteID && createFromCloud && showStep === 0">{{$t('project.Skip')}}</el-button>
      <el-steps :active="showStep"
                v-show="!jobsiteID"
                style="margin-bottom: 20px;"
                simple>
        <el-step :title="`1. `+$t('project.SelectPlan')"
                 v-show="createFromCloud || createFromPdf"
                 style="word-break: break-word"></el-step>
        <el-step :title="`2. `+$t('project.SelectLayers')"
                 v-show="createFromCloud"
                 style="word-break: break-word"></el-step>
        <el-step :title="(createFromCloud?`3. `:(createFromPdf?`2. `:`1. `))+$t('project.EnterInformation')"
                 style="word-break: break-word"></el-step>
        <el-step :title="(createFromCloud?`4. `:(createFromPdf?`3. `:`2. `))+$t('project.SelectMembers')"
                 style="word-break: break-word"></el-step>
      </el-steps>
      <div class="step-1"
           v-show="showStep === 0 && createFromCloud">
        <el-row style="margin-bottom:10px">
          <el-col>
            <el-input :placeholder="$t('project.SearchforPlans')"
                      size="small"
                      @change="search()"
                      @clear="search()"
                      clearable
                      v-model="condition.Value"></el-input>
          </el-col>
        </el-row>
        <el-table :data="projectList"
                  v-loading="loading"
                  size="small"
                  @row-click="nextStep">
          <el-table-column :label="$t('project.Name')">
            <template slot-scope="scope">
              {{scope.row.Name}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('project.Owner')"
                           width="200">
            <template slot-scope="scope">
              {{scope.row.CreatorAccount}}
            </template>
          </el-table-column>
          <el-table-column :label="$t('project.LastUpdated')"
                           width="150">
            <template slot-scope="scope">
              {{scope.row.LastUpdatedOn.substring(0,10)}}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background
                       small
                       style="margin-top:5px;"
                       @current-change="handleCurrentChange"
                       layout="total, prev, pager, next"
                       :current-page="condition.PageIndex"
                       :page-size="condition.PageSize"
                       :total="projectTotal">
        </el-pagination>
      </div>
      <div class="step-1"
           v-show="showStep === 0 && createFromPdf">
        <addPlanFromPdf ref="addPdfComponent"
                        :allowMultiple="false"
                        @checkPageListChange='checkPageListChange'></addPlanFromPdf>
      </div>
      <div class="step-2"
           v-show="showStep === 1">
        <div class="layer-box">
          <myScroll style="width:100%;height:100%">
            <el-table :data="layerList"
                      ref="tableLayer"
                      @row-click="handleRowClick"
                      @selection-change="handleSelectionChange">
              <el-table-column :label="arraySelectText">
                <template slot-scope="scope">
                  <img :src="scope.row.url"
                       style="width: 120px;height: 120px;"
                       alt="">
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  {{scope.row.Name}}
                </template>
              </el-table-column>
              <el-table-column type="selection"
                               :label="$t('project.SelectAll')"
                               width="55"></el-table-column>
            </el-table>
          </myScroll>
        </div>
      </div>
      <div class="step-3"
           v-show="showStep === 2">
        <el-form label-width="140px"
                 style="width:80%;margin:0 auto"
                 :model="formData"
                 ref="Form"
                 :rules="rules"
                 label-position="left">
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item :label="$t('project.Name')"
                            prop="Name">
                <el-input v-model="formData.Name"
                          autocomplete="new-password"
                          :placeholder="$t('project.Name')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item :label="$t('project.Address')">
                <el-row>
                  <el-col :span="24">
                    <el-input :placeholder="$t('project.Street')"
                              v-model="formData.Street"
                              style="margin-bottom: 20px"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input style="width:96%;margin:0px auto;"
                              :placeholder="$t('project.City')"
                              v-model="formData.City"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input style="width:96%;margin:0px auto;"
                              :placeholder="$t('project.State')"
                              v-model="formData.State"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input style="width:96%;margin:0px auto;"
                              :placeholder="$t('project.ZipCode') "
                              v-model="formData.ZipCode"></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input style="width:96%;margin:0px auto;"
                              v-model="formData.Country"
                              :placeholder="$t('project.Country')"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="step-4"
           v-show="showStep === 3">
        <div class="member-box">
          <el-row style="margin-bottom:5px">
            <el-col :span="24">
              <el-input :placeholder="$t('members.SearchMemberName')"
                        size="small"
                        @change="searchMemeber()"
                        @clear="searchMemeber()"
                        clearable
                        v-model="memeberCondition.FullName"></el-input>
            </el-col>
          </el-row>
          <myScroll style="height:420px">
            <el-table ref="memberTable"
                      :data="userList"
                      v-loading="loading"
                      :highlight-current-row="false"
                      @row-click="selectMemberRow"
                      :row-class-name="tableMemberRowClassName"
                      @selection-change="handleMemberSelectionChange"
                      :row-key="getRowKeys">
              <el-table-column type="selection"
                               :reserve-selection="true"
                               width="42">
              </el-table-column>
              <el-table-column width="45">
                <template slot-scope="scope">
                  <div class="user-logo">
                    <img :src="scope.row.AvatarUrl"
                         alt="">
                  </div>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <div class="text">
                    {{scope.row.FullName}} -- {{$t('api.'+scope.row.RoleName)}}
                  </div>
                  <div class="text">
                    {{scope.row.LoginAccount}}
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </myScroll>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="closeDialog('Form')"
                   size="small">{{$t('project.Cancel')}}</el-button>
        <el-button type="primary"
                   v-if="showStep !== 0 && !jobsiteID  && (createFromCloud || createFromPdf || showStep > 2)"
                   size="small"
                   @click="lastStep">{{$t('project.Previous')}}</el-button>
        <el-button type="primary"
                   v-if="!jobsiteID && ((createFromPdf && showStep === 0) || showStep === 1||showStep === 2)"
                   @click="nextStep"
                   size="small"
                   :disabled="(createFromCloud && layerCheck.length < 1 && showStep !== 2) ||
                            (createFromPdf && checkPageList.length < 1)">{{$t('project.Next')}}</el-button>
        <el-button type="primary"
                   v-if="showStep === 3||jobsiteID.length>0"
                   size="small"
                   @click="save('Form')"
                   :loading="btnLoading">{{$t('project.OK')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getM2Project, getM2ProjectDetail, getLayerList, getProjectDetail, addProject, getCorpUser, uploadFile, newPdfPlanUrlPages } from '@/api/config'
import { mapState } from 'vuex'
import addPlanFromPdf from '@/components/diagrams/addPlanFromPdf.vue'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    createFromCloud: {
      type: Boolean,
      default: false
    },
    createFromPdf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      btnLoading: false,
      skip: false,
      saveLoading: null,
      loading: false,
      title: 'Create Project',
      condition: {
        Value: null,
        PageIndex: 1,
        PageSize: 10,
        OrderBy: 'LastUpdatedOn desc'
      },
      memeberCondition: {
        FullName: null,
        PageIndex: 1,
        PageSize: 1000,
        OrderBy: 'LastUpdatedOn desc'
      },
      userList: [],
      projectList: [],
      projectTotal: 0,
      layerList: [],
      showStep: 0,
      formData: {
        JobsiteId: null,
        Name: null,
        ProjectManager: null,
        InstallationManager: null,
        Subcontract: null,
        Street: null,
        ZipCode: null,
        City: null,
        State: null,
        Country: null,
        Status: 'New',
        M2Plans: [],
        AllowSaveMembers: true,
        MemberUserIds: []
      },
      layerCheck: [],
      checkPageList: [],
      rules: {
        Name: [
          { required: true, message: this.$t('project.PleaseEnterAname'), trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'userInfo']),
    arraySelectText () {
      return this.layerCheck.length > 0 ? this.layerCheck.length + ' ' + this.$t('project.Selected') : this.$t('project.NoneSelected')
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.condition.PageIndex = 1
        this.skip = false
        if (this.jobsiteID.length > 0) {
          this.showStep = 2
          this.title = this.$t('project.EditProject')
          this.getProjectDetail()
        } else {
          this.title = this.$t('project.CreateProject')
          this.getCorpUser()
          if (this.createFromCloud) {
            this.getM2Project()
            this.showStep = 0
          } else if (this.createFromPdf) {
            this.showStep = 0
            this.$nextTick(() => {
              this.$refs.addPdfComponent.clearPdf()
            })
          } else {
            this.showStep = 2
          }
        }
      }
    }
  },
  methods: {
    getRowKeys (row) {
      return row.UserId
    },
    checkPageListChange (data) {
      this.checkPageList = data
    },
    searchMemeber () {
      this.getCorpUser()
    },
    getCorpUser () {
      getCorpUser(this.memeberCondition).then(res => {
        this.userList = []
        res.Data.forEach(u => {
          u.AvatarUrl = this.$config.baseURL + '/api/Attachments/' + u.DocFileId + '?isAvatar=true'
          if (u.UserId !== this.userInfo.UserId) {
            this.userList.push(u)
          }
        })
      })
    },
    handleSkip () {
      this.skip = true
      this.showStep = 2
    },
    handleRowClick (row, column, event) {
      this.$refs.tableLayer.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.layerCheck = val
    },
    handleCurrentChange (val) {
      this.condition.PageIndex = val
      this.getM2Project()
    },
    search () {
      this.condition.PageIndex = 1
      this.getM2Project()
    },
    getM2Project () {
      this.loading = true
      getM2Project(this.condition).then(res => {
        this.projectList = res.Data
        this.projectTotal = res.TotalCount
        this.loading = false
      })
    },
    getLayerList (M2Id) {
      return new Promise((resolve, reject) => {
        getLayerList(M2Id).then(res => {
          resolve(res)
        }).catch(err => {
          console.log(err)
          this.loading = false
        })
      })
    },
    async nextStep (row) {
      this.loading = true
      if (row.ProjectId) {
        if (!this.skip) {
          this.formData.Name = row.Name
        }
        let project = await getM2ProjectDetail(row.ProjectId)
        let projectInfo = project.ProjectInfo
        this.formData.Street = projectInfo.ProjectStreet
        this.formData.City = projectInfo.ProjectCity
        this.formData.State = projectInfo.ProjectState
        this.formData.ZipCode = projectInfo.ProjectZipCode
        this.formData.Country = projectInfo.ProjectCountry
        let list = await this.getLayerList(row.ProjectId)
        list.forEach((res, index) => {
          res.url = this.$config.baseURL + '/api/M2Projects/' + row.ProjectId + '/Layers/' + res.ShapeId + '/Image'
          res.LayerIndex = index
          res.Revision = row.Revision
        })
        this.layerList = list
        this.$refs.tableLayer.toggleAllSelection()
      }
      if (this.showStep === 2) {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            this.showStep += 1
            this.loading = false
            if (this.showStep === 3 && (!this.formData.JobsiteId || this.formData.JobsiteId === '')) {
              this.toggleMemberSelection()
            }
          }
        })
      } else if (this.showStep === 0 && this.createFromPdf) {
        let firstFile = this.checkPageList[0].file
        let index = firstFile.name.lastIndexOf('.')
        this.formData.Name = index > 0 ? firstFile.name.substring(0, index) : firstFile.name
        this.showStep = 2
      } else {
        this.showStep += 1
        this.loading = false
      }
      let target = row.target
      if (target) {
        if (target.nodeName === 'SPAN') {
          target = row.target.parentNode
        }
        target.blur()
      }
    },
    lastStep (e) {
      if (this.showStep === 2) {
        if (!this.skip) {
          this.$set(this.formData, 'ProjectLayers', [])
          if (this.createFromPdf) {
            this.showStep -= 1
          }
        } else {
          this.skip = false
          this.showStep -= 1
        }
      }
      this.showStep -= 1
      let target = e.target
      if (target) {
        if (target.nodeName === 'SPAN') {
          target = e.target.parentNode
        }
        target.blur()
      }
    },
    closeDialog (formName, id) {
      if (this.showStep === 2) {
        this.$refs[formName].clearValidate()
        this.$refs[formName].resetFields()
      }
      if (id) {
        this.$emit('closeDialog', id)
      } else {
        this.condition.Value = null
        this.$emit('closeDialog')
      }
      if (this.showStep === 3) {
        this.userList = []
        this.memeberCondition.FullName = null
        this.$refs.memberTable.clearSelection()
        this.formData = {
          JobsiteId: null,
          Name: null,
          ProjectManager: null,
          InstallationManager: null,
          Subcontract: null,
          Street: null,
          ZipCode: null,
          City: null,
          State: null,
          Country: null,
          Status: 'New',
          M2Plans: [],
          AllowSaveMembers: true,
          MemberUserIds: []
        }
      }
    },
    addPlan (data, count) {
      let that = this
      return new Promise((resolve, reject) => {
        newPdfPlanUrlPages(data, false).then(res => {
          resolve(count)
        }).catch((err) => {
          that.btnLoading = false
          that.saveLoading.close()
          reject(err)
        })
      })
    },
    getConfig (progressList, index) {
      let that = this
      return {
        onUploadProgress: function (progress) {
          progressList[index].loaded = Math.round(progress.loaded)
          progressList[index].total = Math.round(progress.total)
          let loaded = 0
          let total = 0
          for (let progress of progressList) {
            loaded += progress.loaded || 0
            total += progress.total || 0
          }
          let percent = that.$config.getFormatNumber(loaded * 100.0 / total) + '%'
          that.saveLoading.text = that.$t('upload.Uploading') + ' ' + that.$config.formatBytes(loaded) + '/' + that.$config.formatBytes(total) + ' ' + percent
          if (percent === '100%') {
            that.saveLoading.text = that.$t('upload.Waiting')
          }
        }
      }
    },
    save (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveLoading = this.$loading({
            lock: true,
            text: this.$t('taskDialog.Saving'),
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          this.btnLoading = true
          if (!this.skip) {
            this.layerCheck.forEach(ele => {
              let obj = {
                ProjectId: ele.ProjectId,
                LayerShapeId: ele.ShapeId,
                LayerName: ele.Name ? ele.Name : 'layer',
                LayerIndex: ele.LayerIndex,
                Revision: ele.ProjectRevision,
                DiagramName: ele.ProjectName
              }
              this.formData.M2Plans.push(obj)
            })
          }
          this.formData.JobsiteId = this.jobsiteID
          let params = []
          if (!this.formData.MemberUserIds.find(p => p === this.userInfo.UserId)) {
            this.formData.MemberUserIds.push(this.userInfo.UserId)
          }
          params.push(this.formData)
          addProject(params).then(async res => {
            if (res.length > 0) {
              if (that.createFromPdf) {
                let jobsiteId = res[0].JobsiteId
                let totalPlansCount = 0
                let progressList = []
                for (let checkedPdf of this.checkPageList) {
                  progressList.push({ index: checkedPdf.index })
                  totalPlansCount += checkedPdf.pages.length
                }
                let time = 0
                let uploadArray = []
                let uploadPromises = []
                for (let checkedPdf of this.checkPageList) {
                  let fileData = new FormData()
                  fileData.append('file', checkedPdf.file.raw)
                  let config = that.getConfig(progressList, checkedPdf.index)
                  let uploadPromise = uploadFile(fileData, config).then(async result => {
                    let name = checkedPdf.file.name
                    let index = name.lastIndexOf('.')
                    let fileName = index > 0 ? name.substring(0, index) : name
                    uploadArray.push({ index: checkedPdf.index, url: result.FileUrl, name: fileName })
                  }).catch(err => {
                    console.log(err)
                    that.btnLoading = false
                    that.saveLoading.close()
                  })
                  uploadPromises.push(uploadPromise)
                }
                Promise.all(uploadPromises).then(async ppromiseGroupResult => {
                  for (let checkedPdf of this.checkPageList) {
                    let uploadResult = uploadArray.find(q => q.index === checkedPdf.index)
                    for (let selectPages of this.$config.splitGroupArray(checkedPdf.pages, 10)) {
                      let data = {
                        JobsiteId: jobsiteId,
                        ProjectName: uploadResult.name,
                        PdfUrl: uploadResult.url,
                        Pages: selectPages
                      }
                      time += await that.addPlan(data, selectPages.length)
                      that.saveLoading.text = that.$t('taskDialog.Saving') + '  total: ' + time + '/' + totalPlansCount
                    }

                    if (time === totalPlansCount) {
                      that.btnLoading = false
                      that.saveLoading.close()
                      that.$refs.addPdfComponent.clearPdf()
                      that.closeDialog(formName, jobsiteId)
                    }
                  }
                })
              } else {
                that.btnLoading = false
                that.saveLoading.close()
                that.closeDialog(formName, res[0].JobsiteId)
              }
            }
          }).catch(err => {
            console.log(err)
            that.btnLoading = false
            that.saveLoading.close()
          })
        } else {
          return false
        }
      })
    },
    getProjectDetail () {
      getProjectDetail(this.jobsiteID).then(res => {
        this.formData.Name = res.Name
        this.formData.ProjectManager = res.ProjectManager
        this.formData.InstallationManager = res.InstallationManager
        this.formData.Subcontract = res.Subcontract
        this.formData.Street = res.Street
        this.formData.ZipCode = res.ZipCode
        this.formData.City = res.City
        this.formData.State = res.State
        this.formData.Country = res.Country
        this.formData.Status = res.Status
        this.formData.MemberUserIds = res.MemberUserIds
        this.formData.IsClosed = res.IsClosed
      })
    },
    selectMemberRow (row) {
      this.selectedId = row.UserId
    },
    tableMemberRowClassName ({ row, rowIndex }) {
      if (this.selectedId === row.UserId) {
        return 'success-row'
      }
    },
    handleMemberSelectionChange (val) {
      this.formData.MemberUserIds = []
      val.forEach(res => {
        this.formData.MemberUserIds.push(res.UserId)
      })
    },
    toggleMemberSelection () {
      this.$refs.memberTable.data.forEach(row => {
        if (row.UserId === this.userInfo.UserId) {
          this.$refs.memberTable.toggleRowSelection(row, true)
        }
      })
    }
  },
  components: {
    addPlanFromPdf
  }
}
</script>

<style scoped lang="scss">
/deep/.el-table-column--selection
  .cell
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner {
  width: 18px;
  height: 18px;
}

/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  top: 7px;
}

/deep/.el-checkbox__inner::after {
  height: 7px;
  left: 6px;
  top: 3px;
}

/deep/.el-table-column--selection .cell {
  padding-left: 10px;
  padding-right: 10px;
  text-overflow: unset;
}

/deep/.el-step.is-simple:not(:last-of-type) .el-step__title {
  word-break: break-word;
}
/deep/.member-box {
  .el-table th,
  .el-table td {
    padding: 6px 0;
  }
}
/deep/.el-step__head {
  display: none;
}
.step-1 {
  .el-pagination {
    margin-top: 10px;
    text-align: right;
  }
}
.step-2 {
  .layer-box {
    width: 100%;
    height: 480px;
    img {
      width: 120px;
      height: 120px;
    }
  }
}

.member-box {
  width: 100%;
  height: 480px;
}

.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 10;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
